/**
 * Takes in a set of keys for `State` whose values are interdependent boolean
 * values (meaning, at most, one can be true at a time), and returns a state
 * update function that takes in the state, key to update, and boolean value
 * to update that key to. It will then set the value of the key, making sure
 * that if the value is true, all interdependent values are set to false.
 *
 * It also uses `KeysByType` to limit the keys passed to those in the state that
 * have boolean values.
 */
export const setInterdependentBoolState = (keys) => (state, key, val) => state[key] === val
    ? state
    : keys.reduce((newS, k) => {
        const v = k === key ? val : val ? !val : state[k];
        return v === state[k] ? newS : { ...newS, [k]: v };
    }, state);
// NOTE: More efficient version if needed
// export const setInterdepBoolState =
// 	<State, InterdependentKey extends KeysByType<State, boolean>>(
// 		keys: readonly InterdependentKey[],
// 	) =>
// 	(state: State, key: InterdependentKey, val: State[InterdependentKey]): State => {
// 		if (state[key] === val) return state
//
// 		let didCopy = false
//
// 		return keys.reduce((newState, k) => {
// 			const v = k === key ? val : val ? !val : state[k]
//
// 			if (v === state[k]) return newState
//
// 			if (!didCopy) {
// 				newState = { ...newState }
// 				didCopy = true
// 			}
//
// 			newState[k] = v as State[InterdependentKey]
//
// 			return newState
// 		}, state)
// 	}
//# sourceMappingURL=setInterdependentBoolState.js.map